module.exports = __webpack_public_path__ + "uploadPrivatePortfolios.34904d6c02051662e26c494a56c934db.png";